$(document).ready(function () {
  if ($(".magic-8-ball").length) {

    $('.eight-ball').click(function () {
      $(this).effect("shake", {
        times: 3
      }, 1000);

      setTimeout(fadeOutQuestion, 1000);
      setTimeout(updateHeadline, 1000);
    });
  }
});

function fadeOutQuestion() {
  if ($(".eight-ball .braindo").css("display") != "none") {
    $(".eight-ball .braindo").fadeOut(1000);
    $(".answer-1").fadeIn(2000);
    return;
  }
  if ($(".answer-1").css("display") == "block") {
    $(".answer-1").fadeOut(1000);
    $(".answer-2").fadeIn(3000);
    return;
  }
  if ($(".answer-2").css("display") == "block") {
    $(".answer-2").fadeOut(1000);
    $(".answer-3").fadeIn(3000);
    return;
  }
  if ($(".answer-3").css("display") == "block") {
    $(".answer-3").fadeOut(1000);
    $(".answer-4").fadeIn(3000);
    return;
  }
  if ($(".answer-4").css("display") == "block") {
    $(".answer-4").fadeOut(1000);
    $(".answer-5").fadeIn(3000);
    return;
  }
  if ($(".answer-5").css("display") == "block") {
    $(".answer-5").fadeOut(1000);
    $(".answer-6").fadeIn(3000);
    return;
  }
  if ($(".answer-6").css("display") == "block") {
    $(".answer-6").fadeOut(1000);
    $(".answer-7").fadeIn(3000);
    return;
  }
  if ($(".answer-7").css("display") == "block") {
    $(".answer-7").fadeOut(1000);
    $(".answer-8").fadeIn(3000);
    return;
  }
  if ($(".answer-8").css("display") == "block") {
    $(".answer-8").fadeOut(1000);
    $(".answer-9").fadeIn(3000);
    return;
  }
  if ($(".answer-9").css("display") == "block") {
    $(".answer-9").fadeOut(1000);
    $(".answer-10").fadeIn(3000);
    return;
  }
  if ($(".answer-10").css("display") == "block") {
    $(".answer-10").fadeOut(1000);
    $(".answer-11").fadeIn(3000);
    return;
  }
  if ($(".answer-11").css("display") == "block") {
    $(".answer-11").fadeOut(1000);
    $(".answer-12").fadeIn(3000);
    return;
  }
  if ($(".answer-12").css("display") == "block") {
    $(".answer-12").fadeOut(1000);
    $(".answer-13").fadeIn(3000);
    return;
  }
  if ($(".answer-13").css("display") == "block") {
    $(".answer-13").fadeOut(1000);
    $(".answer-14").fadeIn(3000);
    return;
  }
  if ($(".answer-14").css("display") == "block") {
    $(".answer-14").fadeOut(1000);
    $(".answer-15").fadeIn(3000);
    return;
  }
  if ($(".answer-15").css("display") == "block") {
    $(".answer-15").fadeOut(1000);
    $(".answer-16").fadeIn(3000);
    return;
  }
  if ($(".answer-16").css("display") == "block") {
    $(".answer-16").fadeOut(1000);
    $(".answer-17").fadeIn(3000);
    return;
  }
  if ($(".answer-17").css("display") == "block") {
    $(".answer-17").fadeOut(1000);
    $(".answer-18").fadeIn(3000);
    return;
  }
  if ($(".answer-18").css("display") == "block") {
    $(".answer-18").fadeOut(1000);
    $(".answer-19").fadeIn(3000);
    return;
  }
  if ($(".answer-19").css("display") == "block") {
    $(".answer-19").fadeOut(1000);
    $(".answer-20").fadeIn(3000);
    return;
  }
  if ($(".answer-20").css("display") == "block") {
    $(".answer-20").fadeOut(1000);
    $(".answer-21").fadeIn(3000);
    return;
  }
  if ($(".answer-21").css("display") == "block") {
    $(".answer-21").fadeOut(1000);
    $(".answer-22").fadeIn(3000);
    return;
  }
  if ($(".answer-22").css("display") == "block") {
    $(".answer-22").fadeOut(1000);
    $(".answer-23").fadeIn(3000);
    return;
  }
  if ($(".answer-23").css("display") == "block") {
    $(".answer-23").fadeOut(1000);
    $(".answer-24").fadeIn(3000);
    return;
  }
  if ($(".answer-24").css("display") == "block") {
    $(".answer-24").fadeOut(1000);
    $(".eight-ball .braindo").fadeIn(3000);
    return;
  }
}

function updateHeadline() {
  if ($("#magic-header").text() == "Click the Magic 8 Ball to give it a shake!") {
    $("#magic-header").text("I participated in my first Fencing competition in 2016.");
    return;
  }
  if ($("#magic-header").text() == "I participated in my first Fencing competition in 2016.") {
    $("#magic-header").text("I did a bungee jump from where the bungee jump originated: Kawarau Bridge in Queenstown, NZ.");
    return;
  }
  if ($("#magic-header").text() == "I did a bungee jump from where the bungee jump originated: Kawarau Bridge in Queenstown, NZ.") {
    $("#magic-header").text("I testified in front of the Philly City Council once.");
    return;
  }
  //4
  if ($("#magic-header").text() == "I testified in front of the Philly City Council once.") {
    $("#magic-header").text("I lived in Peru for a year.");
    return;
  }
  //5
  if ($("#magic-header").text() == "I lived in Peru for a year.") {
    $("#magic-header").text("I share a birthday with BrainDo.");
    return;
  }
  //6
  if ($("#magic-header").text() == "I share a birthday with BrainDo.") {
    $("#magic-header").text("I am related to the founder of Cranberry Township, PA.");
    return;
  }
  //7
  if ($("#magic-header").text() == "I am related to the founder of Cranberry Township, PA.") {
    $("#magic-header").text("I once drove to Massachusetts from Philadelphia to buy beer.");
    return;
  }
  //8
  if ($("#magic-header").text() == "I once drove to Massachusetts from Philadelphia to buy beer.") {
    $("#magic-header").text("I have made and worn 14th Century recreation clothing.");
    return;
  }
  //9
  if ($("#magic-header").text() == "I have made and worn 14th Century recreation clothing.") {
    $("#magic-header").text("I have a relative who plays professional soccer in the MLS.");
    return;
  }
  //10
  if ($("#magic-header").text() == "I have a relative who plays professional soccer in the MLS.") {
    $("#magic-header").text("I once planked in perfect posture for 10 minutes.");
    return;
  }
  //11
  if ($("#magic-header").text() == "I once planked in perfect posture for 10 minutes.") {
    $("#magic-header").text("I once drove 14 hours to see a Dave Matthews band concert at the Gorge and then drove back home right after.");
    return;
  }
  //12
  if ($("#magic-header").text() == "I once drove 14 hours to see a Dave Matthews band concert at the Gorge and then drove back home right after.") {
    $("#magic-header").text("I am an avid fan of horses and currently train with a horse named Onyx.");
    return;
  }
  //13
  if ($("#magic-header").text() == "I am an avid fan of horses and currently train with a horse named Onyx.") {
    $("#magic-header").text("I was quoted on CBS 3 News for saying \"holy cow\" when a cow escaped a holiday manger set.");
    return;
  }
  //14
  if ($("#magic-header").text() == "I was quoted on CBS 3 News for saying \"holy cow\" when a cow escaped a holiday manger set.") {
    $("#magic-header").text("I currently own 14 keyboards.");
    return;
  }
  //15
  if ($("#magic-header").text() == "I currently own 14 keyboards.") {
    $("#magic-header").text("I homebrew mead.");
    return;
  }
  //16
  if ($("#magic-header").text() == "I homebrew mead.") {
    $("#magic-header").text("I like dinner for breakfast.");
    return;
  }
  //17
  if ($("#magic-header").text() == "I like dinner for breakfast.") {
    $("#magic-header").text("I was 25 years old when I saw snow in person for the first time.");
    return;
  }
  //18
  if ($("#magic-header").text() == "I was 25 years old when I saw snow in person for the first time.") {
    $("#magic-header").text("I climbed over ten 14,000 ft mountains.");
    return;
  }
  //19
  if ($("#magic-header").text() == "I climbed over ten 14,000 ft mountains.") {
    $("#magic-header").text("I really enjoy chocolate gel as a topping.");
    return;
  }
  //20
  if ($("#magic-header").text() == "I really enjoy chocolate gel as a topping.") {
    $("#magic-header").text("I was the 3rd team member after Jenny and Brian at BrainDo.");
    return;
  }
  //21
  if ($("#magic-header").text() == "I was the 3rd team member after Jenny and Brian at BrainDo.") {
    $("#magic-header").text("I love chonky animals and wholesome memes.");
    return;
  }
  //22
  if ($("#magic-header").text() == "I love chonky animals and wholesome memes.") {
    $("#magic-header").text("My hair is currently the longest it has ever been and I have no plan on cutting it any time soon.");
    return;
  }
  //23
  if ($("#magic-header").text() == "My hair is currently the longest it has ever been and I have no plan on cutting it any time soon.") {
    $("#magic-header").text("My last rock concert had to be shut down by the Fire Marshall because so many people showed up the building almost collapsed.");
    return;
  }
  //24
  if ($("#magic-header").text() == "My last rock concert had to be shut down by the Fire Marshall because so many people showed up the building almost collapsed.") {
    $("#magic-header").text("I have 6 siblings.");
    return;
  }
  //25 - repeat
  if ($("#magic-header").text() == "I have 6 siblings.") {
    $("#magic-header").text("Click the Magic 8 Ball to give it a shake!");
    return;
  }
}